import React from 'react';
import { useNavigate } from 'react-router-dom';
import { QuickMenu, useQuickMenus } from '../../hooks/useQuickMenus';
import { useAppDispatch } from '../../store/hook';
import ModalAlert from '../modal/ModalAlert';
import { openModal } from '../../store/features/modalSlice';

const FALLBACK_ICON = process.env.PUBLIC_URL + 'svg/home/mybadge.svg';

const GRID_CLASS = 'grid grid-cols-4 gap-[19px] lg:mx-0 lg:grid-cols-8';

const ITEM_CLASS = 'flex flex-col gap-1 lg:gap-[15px]';

/* '내 학습\n(교사대학)'과 같이 라벨이 최대 2줄일 수 있음. 모든 라벨 min-height를 2줄 높이(3em)로 통일. (leading-tight(1.25) 기준 2줄은 2.5em, 3em은 여유값)*/
const LABEL_CLASS = 'flex min-h-[3em] justify-center';

// 젭스 메인 바로가기 메뉴 그리드
const QuickMenuGrid = () => {
  const { menus, loading } = useQuickMenus();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleMenuClick = (menu: QuickMenu) => {
    if (!menu.isLinkActive || menu.linkType === 'NONE' || !menu.linkUrl) {
      dispatch(
        openModal({ body: <ModalAlert message="준비중인 기능입니다." /> }),
      );
      return;
    }

    if (menu.linkType === 'NEW_TAB') {
      window.open(menu.linkUrl);
      return;
    }

    // 외부 주소는 라우터로 이동할 수 없어 현재 탭을 교체한다
    if (/^https?:\/\//.test(menu.linkUrl)) {
      window.location.href = menu.linkUrl;
      return;
    }

    navigate(menu.linkUrl);
  };

  // 스켈레톤. 아이콘 영역 높이를 실제 목록과 맞춰 로딩 후 레이아웃이 밀리지 않게 한다
  if (loading) {
    return (
      <div className={GRID_CLASS}>
        {Array.from({ length: 8 }, (_, i) => (
          <div key={i} className={ITEM_CLASS}>
            <div className="aspect-square w-full animate-pulse rounded-[8px] bg-gray2" />
            <div className={LABEL_CLASS}>
              <div className="h-4 w-4/5 animate-pulse rounded bg-gray2" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={GRID_CLASS}>
      {menus.map((menu) => (
        <button
          key={menu.id}
          type="button"
          className={`group relative ${ITEM_CLASS}`}
          onClick={() => {
            handleMenuClick(menu);
          }}
        >
          <div className="bg-gray-00 m-auto w-full rounded-[8px]">
            <img
              src={menu.iconUrl || FALLBACK_ICON}
              alt={menu.name}
              className="object-cover transition-transform duration-100 ease-in-out group-hover:scale-110"
            />
          </div>
          <h4
            className={`${LABEL_CLASS} items-start whitespace-pre-line text-center text-xs font-semibold leading-tight sm:text-sm md:text-lg`}
          >
            {menu.name}
          </h4>
        </button>
      ))}
    </div>
  );
};

export default QuickMenuGrid;
